import { Star, Quote } from "lucide-react";

const REVIEWS = [
  {
    id: "review-rahul",
    name: "Rahul K.",
    role: "Apartment Owner",
    location: "JLT, Dubai",
    rating: 5,
    text: "Fix Technical Renovation Company is hands down the best renovation contractor in Dubai. They completely transformed our 2-bedroom apartment in JLT — premium finishing, transparent communication, and zero hidden costs. Highly recommend.",
  },
  {
    id: "review-sarah",
    name: "Sarah M.",
    role: "Villa Resident",
    location: "Damac Hills, Dubai",
    rating: 5,
    text: "We hired Fix Technical Renovation Company for a luxury villa renovation in Damac Hills. They managed all authority approvals and delivered high-end finishing on time. Excellent project management.",
  },
];

function Stars({ count = 5 }) {
  return (
    <div className="flex items-center gap-0.5" aria-label={`${count} out of 5 stars`}>
      {Array.from({ length: 5 }).map((_, i) => (
        <Star
          key={i}
          className={`w-4 h-4 ${i < count ? "fill-[#F4B400] text-[#F4B400]" : "text-neutral-300"}`}
        />
      ))}
    </div>
  );
}

function GoogleLogo() {
  return (
    <svg viewBox="0 0 48 48" className="w-4 h-4" aria-hidden="true">
      <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8a12 12 0 1 1 7.6-21.3l5.7-5.7A20 20 0 1 0 44 24c0-1.2-.1-2.4-.4-3.5z"/>
      <path fill="#FF3D00" d="m6.3 14.7 6.6 4.8C14.6 16 18.9 13 24 13c3 0 5.8 1.1 7.9 3l5.7-5.7A20 20 0 0 0 6.3 14.7z"/>
      <path fill="#4CAF50" d="M24 44c5.2 0 10-2 13.5-5.2l-6.2-5.3a12 12 0 0 1-7.3 2.5c-5.2 0-9.6-3.3-11.2-8L6.2 33A20 20 0 0 0 24 44z"/>
      <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.2 5.7l6.2 5.3A19.9 19.9 0 0 0 44 24c0-1.2-.1-2.4-.4-3.5z"/>
    </svg>
  );
}

export default function Reviews() {
  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="py-20 lg:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto mb-12 lg:mb-16">
          <div className="inline-flex items-center gap-2 mb-4 px-3 py-1.5 border border-neutral-200 bg-[#F9F8F6]">
            <GoogleLogo />
            <span className="text-[11px] uppercase tracking-[0.25em] text-neutral-600 font-semibold">
              Client Reviews
            </span>
            <span className="text-[11px] text-neutral-400">|</span>
            <div className="flex items-center gap-1.5">
              <Stars count={5} />
              <span className="text-xs font-medium text-neutral-700">5.0</span>
            </div>
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-neutral-900 mb-4 leading-[1.1]">
            What Clients Say About Their Renovation Experience
          </h2>
          <p className="text-base lg:text-lg text-neutral-600">
            Real feedback from apartment and villa renovation clients across Dubai.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 lg:gap-7">
          {REVIEWS.map((r) => (
            <article
              key={r.id}
              data-testid={r.id}
              className="group relative bg-white border border-neutral-200 p-7 lg:p-9 transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_24px_60px_rgba(0,0,0,0.06)] hover:border-[#C5A059]"
            >
              <Quote className="absolute top-6 right-6 w-10 h-10 text-[#C5A059]/15 group-hover:text-[#C5A059]/25 transition-colors" aria-hidden="true" />
              <div className="flex items-center gap-3 mb-5">
                <Stars count={r.rating} />
                <span className="text-xs text-neutral-500">Verified Google Review</span>
              </div>

              <blockquote className="text-base lg:text-lg text-neutral-800 leading-relaxed font-light mb-6">
                &ldquo;{r.text}&rdquo;
              </blockquote>

              <div className="flex items-center gap-3 pt-5 border-t border-neutral-100">
                <div className="w-11 h-11 rounded-full bg-[#C5A059]/15 flex items-center justify-center font-heading text-base font-medium text-[#A88746]">
                  {r.name.charAt(0)}
                </div>
                <div>
                  <p className="font-heading text-sm font-medium text-neutral-900">{r.name}</p>
                  <p className="text-xs text-neutral-500">{r.role} · {r.location}</p>
                </div>
                <div className="ml-auto"><GoogleLogo /></div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
